import { ChangeDetectorRef, Component } from '@angular/core';
import { BaseSiteService, CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, map } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
    selector: 'app-registration-uk-thankyou',
    templateUrl: './registration-uk-thankyou.component.html',
    styleUrls: ['./registration-uk-thankyou.component.scss'],
    standalone: false
})
export class RegistrationUkThankyouComponent {
  currentSite: any;
  isNonWebEnabled: boolean = false;

  pageLabel:Observable<string> | undefined;

  constructor(public thankyouComponent: CmsComponentData<any>,private cmsService:CmsService,private baseSiteService:BaseSiteService,private userInfoService:UserInfoService,private cdr:ChangeDetectorRef) {
    this.pageLabel = this.cmsService.getCurrentPage().pipe(map((pageDta) => pageDta.label || ""));
  }

  ngOnInit(): void {
    this.baseSiteService.getActive().subscribe(site => {
      this.currentSite = site;
    });
    this.userInfoService.userLoggedIn$.subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this.userInfoService.getUserData().subscribe(res => {
          if (res) {
            this.isNonWebEnabled = res.webEnabled == false;
            this.cdr.detectChanges();
          }
        });
      }
    });

  }
 
  regThankYouData: Observable<any> = this.thankyouComponent.data$;

  isUkNonWebEnabled(): boolean {
    return this.currentSite == 'seqirusb2b-uk' && this.isNonWebEnabled;
  }

  isThankYouPage():Observable<boolean> | undefined{
    return this.pageLabel?.pipe(map((label) => label === 'register-thank-you' || label === 'regThankYou'));
  }
}
